import { DsTreeItem } from '@bmw-ds/components';

export const sortTreeRecursively = (nodes: DsTreeItem[]): void => {
  nodes.sort((first, second) =>
    first.label.localeCompare(second.label, undefined, { sensitivity: 'base' })
  );
  for (const node of nodes) {
    if (node.children && node.children.length > 0) {
      sortTreeRecursively(node.children);
    }
  }
};

export const expandTreeToId = (
  nodes: readonly DsTreeItem[],
  activeId: string
): DsTreeItem[] =>
  nodes.map((node) => {
    const onPath = activeId === node.id || activeId.startsWith(`${node.id}.`);
    const children = node.children?.length
      ? expandTreeToId(node.children, activeId)
      : node.children;
    return {
      ...node,
      ...(children ? { children } : {}),
      isOpen: onPath || node.isOpen,
      isSelected: activeId === node.id,
    };
  });

export const filterTranslationTree = (
  nodes: readonly DsTreeItem[],
  term: string
): DsTreeItem[] => {
  const trimmed = term.trim().toLowerCase();
  if (!trimmed) {
    return [...nodes];
  }

  const result: DsTreeItem[] = [];
  for (const node of nodes) {
    const selfMatch =
      node.label.toLowerCase().includes(trimmed) ||
      String(node.id).toLowerCase().includes(trimmed);
    if (selfMatch) {
      result.push({ ...node, isOpen: true });
      continue;
    }
    if (node.children && node.children.length > 0) {
      const filteredChildren = filterTranslationTree(node.children, trimmed);
      if (filteredChildren.length > 0) {
        result.push({ ...node, children: filteredChildren, isOpen: true });
      }
    }
  }
  return result;
};
